import { Props } from '~/containers/Drivers';

function meetsDataDependencies(props: Props) {
  const {
    application: { autoApplicants, homeApplicants },
  } = props;

  return autoApplicants.length > 0 || homeApplicants.length > 0;
}

const step = {
  route: '/homeowners-insurance/quotes/drivers',
  breadcrumbStep: 'auto',
  isAccessible: ({ application }: Props): boolean => application.bundled || application.isAutoOnly,
  meetsDataDependencies,
};

export default step;
